import "retinajs";
import "@lottiefiles/lottie-player";
import Alpine from "alpinejs";
import trap from '@alpinejs/trap'
import desktopNavigation from "./modules/desktopNavigation.js";
import mobileNavigation from "./modules/mobileNavigation.js";

Alpine.plugin(trap)
Alpine.data("desktopNavigation", desktopNavigation);
Alpine.store("mobileNavigation", mobileNavigation());

window.Alpine = Alpine;

import { ajaxItems } from "./modules/ajaxItems";
import { frontPage } from "./modules/frontPage";
import { pricePage } from "./modules/pricePage";
import { archiveRental } from "./modules/archiveRental";
import { singlePage } from "./modules/singlePage";
import { contactPage } from "./modules/contactPage";
import { exhibitionPage } from "./modules/exhibitionPage";
import { smoothScroll } from "./modules/smoothScroll";

window.addEventListener("DOMContentLoaded", () => {
  ajaxItems();
  frontPage();
  pricePage();
  archiveRental();
  singlePage();
  contactPage();
  exhibitionPage();
  smoothScroll();
  Alpine.start();
});
